<template>
  <div class="public-shop">
    <header class="shop-header" :style="{ background: themeGradient }">
      <div class="container py-3">
        <router-link :to="shopPath('')" class="header-link">
          <i class="fas fa-arrow-left"></i> Kembali ke Toko
        </router-link>
      </div>
    </header>

    <div class="container mt-4">
      <h3 class="page-title mb-4"><i class="fas fa-shopping-cart text-primary"></i> Keranjang Belanja</h3>

      <div v-if="cart.length === 0" class="empty-state">
        <i class="fas fa-shopping-basket empty-state-icon"></i>
        <h4>Keranjang masih kosong</h4>
        <p class="text-muted">Yuk, pilih produk favoritmu dulu!</p>
        <router-link :to="shopPath('')" class="btn btn-primary btn-lg">Belanja Sekarang</router-link>
      </div>

      <div v-else class="row">
        <div class="col-lg-8">
          <div class="shop-card p-3 mb-3" v-for="(item, i) in cart" :key="i">
            <div class="row align-items-center">
              <div class="col-3 col-md-2">
                <img :src="productImage(item.image_url, item.type)" class="img-fluid rounded item-thumb" :alt="item.product_name">
              </div>
              <div class="col-9 col-md-5">
                <h6 class="mb-1">{{ item.product_name }}</h6>
                <small v-if="hasVariants(item)" class="text-muted d-block">{{ formatVariants(item) }}</small>
                <p class="text-primary mb-0 mt-1">{{ formatRupiah(item.price) }}</p>
              </div>
              <div class="col-6 col-md-3 mt-2 mt-md-0">
                <div class="qty-control d-flex align-items-center">
                  <button class="btn btn-sm btn-light" @click="updateQty(i, item.quantity - 1)">−</button>
                  <input type="number" v-model.number="item.quantity" class="form-control mx-2 qty-input" @change="updateQty(i, item.quantity)">
                  <button class="btn btn-sm btn-light" @click="updateQty(i, item.quantity + 1)">+</button>
                </div>
              </div>
              <div class="col-6 col-md-2 text-right mt-2 mt-md-0">
                <p class="mb-1"><b>{{ formatRupiah(item.price * item.quantity) }}</b></p>
                <button class="btn btn-sm btn-link text-danger p-0" @click="remove(i)">
                  <i class="fas fa-trash"></i> Hapus
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-4">
          <div class="shop-card p-4 summary-card">
            <h5 class="mb-3">Ringkasan</h5>
            <div class="d-flex justify-content-between mb-2">
              <span>Subtotal ({{ cartCount }} item)</span>
              <b>{{ formatRupiah(cartTotal) }}</b>
            </div>
            <small class="text-muted d-block mb-3">Ongkir dihitung di halaman checkout</small>
            <router-link :to="shopPath('/checkout')" class="btn btn-primary btn-lg btn-block">
              Lanjut Checkout <i class="fas fa-arrow-right ml-1"></i>
            </router-link>
            <router-link :to="shopPath('')" class="btn btn-light btn-block mt-2">Tambah Produk Lain</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import publicShopPaths from './public_shop_paths';
import { applyShopTheme, shopHeaderBackground, productImage, shopPublicMixin } from '@/components/shop_public/shop_public_utils';
import '@/components/shop_public/shop_public.css';

export default {
  mixins: [publicShopPaths, shopPublicMixin],
  computed: {
    ...mapState({ cart: s => s.public_shop.cart, shop: s => s.public_shop.shop }),
    ...mapGetters({ cartTotal: 'public_shop/cartTotal', cartCount: 'public_shop/cartCount' }),
    themeGradient() {
      return shopHeaderBackground(this.shop);
    },
  },
  watch: {
    shop: {
      immediate: true,
      handler(s) { if (s) applyShopTheme(s); },
    },
  },
  mounted() {
    this.$store.dispatch('public_shop/cart_load', this.effectiveSlug);
    if (!this.shop) this.$store.dispatch('public_shop/public_get_shop', this.effectiveSlug);
  },
  methods: {
    productImage,
    updateQty(i, qty) {
      qty = Math.max(0, parseInt(qty) || 0);
      this.$store.dispatch('public_shop/cart_update', { index: i, quantity: qty });
    },
    remove(i) {
      if (!confirm('Hapus item ini dari keranjang?')) return;
      this.$store.dispatch('public_shop/cart_remove', i);
    },
    hasVariants(item) {
      return item.selected_variants && Object.keys(item.selected_variants).length > 0;
    },
    formatVariants(item) {
      return Object.entries(item.selected_variants || {}).map(([k, v]) => `${k}: ${v}`).join(', ');
    },
  },
};
</script>

<style scoped>
.page-title {
  font-weight: 600;
}
.item-thumb {
  aspect-ratio: 1;
  object-fit: cover;
}
.qty-input {
  width: 52px;
  text-align: center;
  padding-left: 4px;
  padding-right: 4px;
}
.summary-card {
  position: sticky;
  top: 20px;
}
</style>
